export default "__VITE_ASSET__CBQZs4xy__"